// import Vue from "vue";   //引入发票页面需要

let sideBarLinks = [
    {
        name: '账户信息', index: '1', icon: 'el-icon-goods',
        list: [
            {
                index: '1-1',
                name: '个人信息',
                url: '/UserInfo',
            },
            // {
            //     index: '1-2',
            //     name: '修改密码',
            //     url: '/ResetPassword',
            // },
            {
                index: '1-3',
                name: '投诉建议',
                url: '/FeedBack',
            },
            {
                index: '1-4',
                name: '我的推广',
                url: '/PromoteList',
            },

        ]
    },
    {
        name: '我的参与', index: '2', icon: 'el-icon-setting',
        list: [
            {
                index: '2-1',
                name: '参与公司',
                url: '/PermissionCompanyList',
            },
            {
                index: '2-2',
                name: '参与审核',
                url: '/SelectCompany',
            }
        ]
    },
    {
        name: '我的公司', index: '3', icon: 'el-icon-document',
        list: [{
            index: '3-1',
            name: '公司信息',
            url: '/CompanyInformation',
        },
            {
                index: '3-2',
                name: '公司注册',
                url: '/RegisterState',
            },
        ]
    },

]
// if(!Vue.prototype.$isMobile) {
//     sideBarLinks[0].list.push({
//         index: '1-4',
//         name: '发票管理',
//         url: '/receiptManage'
//     })
// }
export default sideBarLinks
